import React, {Component} from 'react';
import Styles from './style.css';
import {userRegister} from "../../services/userRegister";
import {tokenRegister} from "../../services/tokenRegister";
import {langRegister} from "../../services/langRegister";
import cx from "classnames";
import {quotesRegister} from "../../services/quotesRegister";
import {cartRegister} from "../../services/cartRegister";
import {imagesRegister} from "../../services/imagesRegister";
import {demoRegister} from "../../services/demoRegister";
import {salesChannelRegister} from "../../services/salesChannelRegister";
import queryString from "query-string";
import BoosterHeaderMobile from "../booster-header-mobile/component";
import LanguageButton from "../language-button/component";
import {dataRegister} from "../../services/dataRegister";
import BoosterProperty from "../booster-property/component";

class BoosterHeader extends Component {

    constructor(props) {
        super(props);
        this.state = {
            view: "",
            user: {},
            lang: null,
            temp_lang: null,
            language: false,
            dropdown: false,
            signup: false,
            leave: false,
            home: false,
            profile: false,
            languages: [],
            logout: false,
            private: false
        };
    };

    componentWillMount() {
    }

    componentDidMount() {
        this.setState({
            lang: this.props.lang,
            market: this.props.market
        })
    }

    componentWillReceiveProps(nextProps, nextState) {
        this.setState({
            lang: nextProps.lang,
            market: nextProps.market
        })
    }

    _new() {
        if(dataRegister.getDomain() === "devyieldspotter.com"){
            window.location.replace("https://app.devyieldlock.com");
        }else if(dataRegister.getDomain() === "yieldspotter.com"){
            window.location.replace("https://app.yieldlock.com");
        }else{
            window.location.replace("https://app." + dataRegister.getDomain());
        }
    }

    _openMenu() {
        this.child._openMenu();
    }

    _renderText(item) {
        return langRegister.get("signup-header-one", item, this.state.lang);
    }

    renderYieldlock() {
        try {
            return window.location.hostname.indexOf("yieldlock") !== -1
        } catch (e) {
            return false
        }
    }

    renderYieldspotter() {
        try {
            return window.location.hostname.indexOf("yieldspotter") !== -1
        } catch (e) {
            return false
        }
    }

    render() {
        return (
            <div>
                <div className={Styles.header}>
                    <div className={Styles.logoContainer}>
                        {
                            !this.renderYieldspotter() &&
                            <a href={"/" + this.state.market + "/" + this.state.lang}>
                                <img className={Styles.logoContainerIcon} src={salesChannelRegister.get('logo')}/>
                            </a>
                        }
                        {
                            !this.renderYieldspotter() &&
                            <a href={"/" + this.state.market + "/" + this.state.lang}>
                                <img className={Styles.logoContainerIconMobile}
                                     src={salesChannelRegister.get('logo_mobile')}/>
                            </a>
                        }
                        {
                            this.renderYieldspotter() &&
                            <a href={"/" + this.state.market + "/" + this.state.lang}>
                                <img className={Styles.logoContainerIcon}
                                     src={require("../../assets/images/YS_logo_color_signup.png")}/>
                            </a>
                        }
                        {
                            this.renderYieldspotter() &&
                            <a href={"/" + this.state.market + "/" + this.state.lang}>
                                <img className={Styles.logoContainerIconMobile}
                                     src={require("../../assets/images/YS_favicon_color_mobile.png")}/>
                            </a>
                        }
                    </div>
                    <div className={Styles.menuContainer}>
                        {
                            (this.renderYieldlock() || this.renderYieldspotter()) &&
                            <div className={Styles.menuContainerButtons}>
                                <a style={{textDecoration: "none"}} href={"/" + this.state.market + "/" + this.state.lang}>
                                    <div className={
                                        cx(Styles.menuContainerButtonsItem,
                                            {
                                                [Styles.menuContainerButtonsItemActive]: window.location.href.indexOf("sell-with-us") === -1 && window.location.href.indexOf("buy-with-us") === -1
                                            })
                                    }>
                                        {
                                            window.location.href.indexOf("yieldlock") !== -1 ?
                                                (<span>HOME</span>)
                                                :
                                                (<span><span className={Styles.menuContainerButtonsItemMobile}>YIELD</span>&nbsp;DEALS</span>)
                                        }
                                    </div>
                                </a>
                                <a style={{textDecoration: "none"}} href={"/" + this.state.market + "/" + this.state.lang + "/sell-with-us"}>
                                    <div className={
                                        cx(Styles.menuContainerButtonsItem,
                                            {
                                                [Styles.menuContainerButtonsItemActive]: window.location.href.indexOf("sell-with-us") !== -1
                                            })
                                    }>
                                        SELL&nbsp;<span className={Styles.menuContainerButtonsItemMobile}>WITH US</span>
                                    </div>
                                </a>
                                <a style={{textDecoration: "none"}} href={"/" + this.state.market + "/" + this.state.lang + "/buy-with-us"}>
                                    <div className={
                                        cx(Styles.menuContainerButtonsItem,
                                            {
                                                [Styles.menuContainerButtonsItemActive]: window.location.href.indexOf("buy-with-us") !== -1
                                            })
                                    }>
                                        BUY&nbsp;<span className={Styles.menuContainerButtonsItemMobile}>WITH US</span>
                                    </div>
                                </a>
                            </div>
                        }
                    </div>
                    {
                        <div className={Styles.buttonContainer}>
                            <div className={Styles.languageButtonContainer}>
                                <LanguageButton history={this.props.history} market={this.state.market}
                                                lang={this.state.lang}/>
                            </div>
                            {
                                <div onClick={() => this._new()} className={Styles.buttonContainerSignIn}
                                     style={this.renderYieldlock() || this.renderYieldspotter() ? {background: '#00273A'} : {}}>
                                    {this.renderYieldlock() || this.renderYieldspotter() ? this._renderText("item_11") : this._renderText("item_10")}
                                </div>
                            }
                            {
                                !this.renderYieldlock() && !this.renderYieldspotter() &&
                                <img onClick={() => this._openMenu()} className={Styles.buttonContainerMobileMenu}
                                     src={require('../../assets/images/menu_icon.svg')}/>
                            }
                            {
                                (this.renderYieldlock() || this.renderYieldspotter()) &&
                                <img onClick={() => this._openMenu()} className={Styles.buttonContainerMobileMenu}
                                     src={require('../../assets/images/menu_icon_yl.svg')}/>
                            }
                        </div>
                    }
                    <BoosterHeaderMobile history={this.props.history} market={this.state.market} lang={this.state.lang}
                                         props={this.props.props} ref={instance => {
                        this.child = instance
                    }} layout={true}/>
                </div>
            </div>
        );
    }
}

export default BoosterHeader;


// WEBPACK FOOTER //
// ./src/components/booster-header/component.js